import Resources from "shared/actions/resourcesActions";

// eslint-disable-next-line import/prefer-default-export
export class CustomDataTypesResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "custom_data_types", `/api/v1/custom_data_types`);
  }
}
